var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff2E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 51.34 182.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-8{fill:none;}.cls-2{fill:#916657;}.cls-3{fill:#1299a1;}.cls-4{fill:#232323;}.cls-5{fill:#004568;}.cls-6{fill:#0d5278;}.cls-7{fill:#12adb2;}.cls-8{stroke:#1299a1;stroke-miterlimit:10;}.cls-9{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.28 0.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 51.35,
    height: 182.59
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Staff_Male_05b",
    "data-name": "Staff Male 05b",
    viewBox: "0 0 51.34 182.57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.3,99.5l-2.23,2L45,106.35l-2.68,15.22s-.62,17.6-1.67,23.16-1.94,8.51-7.52,7.94c-4.9-.51-3.5-6.06-3.15-11.29s3.69-17.69,4.36-20.1c.81-3,2.24-9.08,3.65-14.63.23-1.44,2.56-5.93,3.16-9.15a21.24,21.24,0,0,1,2.3-6.26C44,89.87,47,86.38,49.7,88.06c.84.52-2,7.68-2,7.68s2.41-3.34,3.41-3.13C52.31,92.86,48.3,99.5,48.3,99.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.71,134.57a66.14,66.14,0,0,0,11.87,2.66,71.49,71.49,0,0,1-.78,8c-1,5.55-3.35,9.67-8.93,9.09-4.9-.5-3.5-6.06-3.15-11.28C29.84,141.26,30.23,138.06,30.71,134.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.48,26.11c0-2.35-.7-5.39,0-6.23s5.78-1.35,8.23-2.86,1.75-3,6.47-3.54c5.78-.67,8.76,1.69,4,4.55-5,3-6.3,3.7-9.45,8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.78,102.08c.35-8.25-1.92-35.88-2.27-45.65s-.7-25.77-.35-29.47-11-6.07-11.38-.51.7,22.74.52,32.51-2.45,41.1-2.45,41.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.69,16.57C7.87,12,5.77,7.14,7.52,3.77s5.77-4,8.4-3.71,3,4,2.1,6.91S15.57,14,15,16.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M9.27,99.78C8.39,89.17,8.08,60.32,6.82,51.94,5.24,41.5,5.07,22.13,5.42,17.75s11.9-6.07,11.72-.84S18.37,38.3,19.42,48.4,28,79.23,29.75,86.81c1.29,5.61.52,14,.52,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M22.28,155.57c11.33,2.38,15.72-4.75,16.63-10s1.22-40.42,1.4-44S30.31,97.7,26,97.36s-15-2.86-15.57,2.7-2.81,33.41-2.81,39.81S8.1,152.5,22.28,155.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.8,157.72c-2.62-.33-6.65-2.52-7.52-4.21s8.92-11.28,8.92-11.28l4.91,6.56,5.07-4c-.35,3.67-3.18,11.58-6.65,12.6S22.8,157.72,22.8,157.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.58,89c-.8,1.5-4.84,4.07-4.84,4.07l-2.52,5.25c-1.28,3.37-2.77,13.43-3.47,17.53a68.61,68.61,0,0,0,4.61,15.83c3.68,8.76,1.06,15.41-2.8,15.66-5.08.34-6.91-5.33-8.48-10.21s-2.35-20.75-2-23.78,2.45-9.52,6-17.54c0,0,2-3.94,3.05-5.87s.77-6.1,2-8.08,5.27-6.15,8.42-5.23c2.13.61-1.79,4.66-2.19,5.67a9.52,9.52,0,0,0,.05,3.53S20.9,81.27,22.05,82,20.38,87.45,19.58,89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.38,155.7l1.4,4.55c-3.33,6.06-3.33,10.11-2.45,13.81S20.53,182,27,181.3s8.64-3.61,9.16-7.31,2.05-15.76,0-17.62-5.95-2-5.95-2l-1.05-5.56a18.1,18.1,0,0,0-7,2.53A19.47,19.47,0,0,0,17.38,155.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.78,160.25c-2.37,1.68-4.38,5.3-4.55,10.44s3.14,12,11.46,11.88,11.31-4.79,12-8.58-8.15-5-12.76-.1A35.58,35.58,0,0,0,23.77,169s-1.34,2.48-3.07.92c-1.31-1.18-1.49-5.81,1.4-6C21.67,162.35,18.78,160.25,18.78,160.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.06,128.38c.52,1.84,1,3.75,1.57,5.65,2.51,9.16-.94,15.42-4.8,15.17-5.08-.32-7.36-5.89-8.28-10.94C1.26,136.73.8,134,.3,130.78A98.57,98.57,0,0,0,13.06,128.38Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 29.11,
    y1: 148.79,
    x2: 31.34,
    y2: 129.43
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering_-_Handlinger",
    "data-name": "Formulering Stabilisering - Handlinger"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("use", {
    width: 51.34,
    height: 182.58,
    transform: "translate(51.34 182.58) rotate(180)",
    xlinkHref: "#Staff_Male_05b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff2E);
export default __webpack_public_path__ + "static/media/staff-2-e.819ac615172a39ce20eb3664fdaa6520.svg";
export { ForwardRef as ReactComponent };